// Import React and Hooks
import React from 'react'
// Import React Router Dom
import { Link } from "react-router-dom"



// Button Props
interface buttonProp {
  additionalClass?:string,
  type?:string,
  url?:string,
  target?:string,
  text:string,
  functionClick?: (e:React.MouseEvent) => void
}

const Button = ( { additionalClass, type = 'default', url = '/', target, text, functionClick }:buttonProp ) => {
  switch( type.toLowerCase() ) {
    case 'submit':
      additionalClass += ' btn--animated btn--submit'
      return (
        <button
          className={`btn ${ additionalClass ? additionalClass : 'btn--default'}`} >
          { text }
        </button>
      )
    case 'animated':
      additionalClass += ' btn--animated'
      return (
        <Link
          to={ url }
          title={ `Enlace a ${text}` }
          onClick={ (e:React.MouseEvent) => functionClick ? functionClick(e) : null }
          className={`btn ${ additionalClass ? additionalClass : 'btn--default'}`} >
          { text }
        </Link>
      )
    case 'video':
      additionalClass += ' btn--video'
      return (
        <Link
          to={ url }
          title={ `Enlace a ${text}` }
          className={`btn ${ additionalClass ? additionalClass : 'btn--default'}`} >
          <span className="btn__play" />
          { text }
        </Link>
      )
    default:
      return (
        <Link
          to={ url }
          title={ `Enlace a ${text}` }
          onClick={ (e:React.MouseEvent) => functionClick ? functionClick(e) : null }
          className={`btn ${ additionalClass ? additionalClass : 'btn--default'}`} >
          { text }
        </Link>
      )
  }
}



export default Button
